import $ from 'jquery';
import {dependency} from "../../utils/request";
import {urlParams} from "../../utils/url";

export default function tagDirective(context = document.body) {
	const $context = $(context);

	// https://cdn.jsdelivr.net/npm/@yaireo/tagify@3.11.3/dist/tagify.min.js
	// https://cdn.jsdelivr.net/npm/@yaireo/tagify@3.11.3/dist/tagify.polyfills.min.js
	const url = 'https://cdn.jsdelivr.net/npm/@yaireo/tagify@3.11.3/dist/tagify.min.js'
	const $tags = $('[sw-tagify]');

	if ($tags.length) {
		dependency(url, () => (window.Tagify && Tagify)).then(function () {

			$('head').append(`<link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/@yaireo/tagify@3.11.3/dist/tagify.css">`);

			$tags.each(function () {
				const _this = $(this);
				const json = JSON.parse(_this.attr('sw-tagify'));

				let query = window.location.search.substring(1);

				let tagSettings = {
					enforceWhitelist: true,
					whitelist: json,
					delimiters: null,
					dropdown: {
						maxItems: 5,
						classname: "tags-look",
						enabled: 0,
						closeOnSelect: false
					},
					originalInputValueFormat: valuesArr => valuesArr.map(item => item.value).join(', ')
				};

				if (query !== '') {
					let parsed = urlParams(query);
					let decoded = decodeURI(parsed.interested);
					_this.val(decoded);
				}

				const tag = new Tagify(this, tagSettings);
			});
		});
	}

}



// WEBPACK FOOTER //
// ./source/scripts/directives/form/tagify.js